var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRK({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724432 9V2.45455H2.48438V3.59659H2.55256C2.67188 3.19034 2.87216 2.88352 3.15341 2.67614C3.43466 2.46591 3.75852 2.3608 4.125 2.3608C4.21591 2.3608 4.31392 2.36648 4.41903 2.37784C4.52415 2.3892 4.61648 2.40483 4.69602 2.42472V4.03551C4.6108 4.00994 4.4929 3.98722 4.34233 3.96733C4.19176 3.94744 4.05398 3.9375 3.92898 3.9375C3.66193 3.9375 3.4233 3.99574 3.21307 4.11222C3.00568 4.22585 2.84091 4.38494 2.71875 4.58949C2.59943 4.79403 2.53977 5.02983 2.53977 5.29688V9H0.724432ZM10.6332 9V10.3764H4.90163V9H10.6332ZM12.9982 7.11648L13.0025 4.93892H13.2667L15.3633 2.45455H17.4471L14.6303 5.74432H14.1999L12.9982 7.11648ZM11.3533 9V0.272727H13.1687V9H11.3533ZM15.4442 9L13.5181 6.14915L14.7283 4.86648L17.5707 9H15.4442Z",
    fill: "rgb(100, 109, 124)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRK);
export default __webpack_public_path__ + "static/media/r_k.2b60dcc99055e2d74a1c86a55743ab2f.svg";
export { ForwardRef as ReactComponent };